import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

export function Navbar({ items = [], className, ...props }) {
  return (
    <nav className={`Navbar ${className || ""}`} {...props}>
      <menu>
        {items.map(({ text, ...rest }, i) => (
          <li key={i}>
            <Link {...rest}>{text}</Link>
          </li>
        ))}
      </menu>
    </nav>
  );
}

export default Navbar;
